import { Tooltip } from '@cambridgeassessment/cambridge-ui';
import { Typography, TypographyProps } from '@material-ui/core';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useStyles } from './styles';

const OverflowTooltip: React.FC<TypographyProps> = ({ children, ...props }) => {
  const textElementRef = useRef(null);
  const [hoverStatus, setHover] = useState(false);

  const compareSize = useCallback(() => {
    const compare =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  }, []);

  const preventShowingBrowserContextMenu = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }, []);

  useEffect(() => {
    compareSize();
  }, [children]);

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
    return () => {
      window.removeEventListener('resize', compareSize);
    };
  }, []);

  const classes = useStyles();

  return (
    <Tooltip title={children} disableHoverListener={!hoverStatus}>
      <Typography
        ref={textElementRef}
        className={classes.text}
        {...props}
        onContextMenu={preventShowingBrowserContextMenu}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};

export default memo(OverflowTooltip);
